<template>
<van-pull-refresh
  v-model="isLoading"
  success-text="刷新成功"
  @refresh="onRefresh"
>
  
  <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" @click="closeToast" :offset="200">
    <div class="order-list" v-for="(item, index) in goodsList" :key="index">
      <div class="flex between center lookbar">
        <div class="size15 weight">
          <p class="a345 size15">{{ item.status == 13? '取消已成功': item.status_name }}</p>
        </div>
        <div class="size12 flex between maxwidth Con">
          <p class="C888">{{ item.add_time }}</p>
          <router-link :to="{
              path: '/shop/accident/returncomplete',
              query: { title: item.status == 25 ? '退货详情' : '订单详情', id: item.order_id, status: 1 },
            }">查看订单</router-link>
        </div>
      </div>
      <div class="flex start">
        <router-link :to="{path: '/shop/detail',query:{goods_id:item.goods_id}}">
          <div class="relative">
              <div class="absolute l t size16  pad2" :class="item.sales_method == 1 ? 'BGshop1' : item.sales_method == 2 ? 'BGshop2' : 'BGshop3' ">{{ item.sales_name }}</div>
              <img :src="item.original_img" :onerror="imgError" class="BGf5 radius8 mr10" />
           </div>
        </router-link>
        <div class="start-right maxwidth">
          <router-link :to="{path: '/shop/detail',query:{goods_id:item.goods_id}}">
            <div>
                <p class="ellipsis weight" v-if="item.status !== 9 ">{{ item.goods_name }}</p>
              <p v-if="item.status == 12 ||item.status == 24" style="color: red" class="size14 a345 flex between">
                <span>待赔付¥{{ item.claim_amount }}</span>
                <span>实付：{{ item.total_amount }}</span>
              </p>
              <div class="flex">
                <p class="a345 ellipsis2  size15 alignleft" style="color:black" v-if="item.status == 5 && item.sales_method == 1">待结账金额：<span
                    style="color: red">{{ item.total_amount }}</span>
                </p>
                <p class="a345 ellipsis2  size15 alignleft" style="color:black" v-if="item.status == 10">待付款金额：<span
                    style="color: red">￥{{ item.total_amount }}</span>
                </p>
                <p v-if="item.status == 9"  class="size12 Cred ellipsis2 w210vw">{{ item.status_desc }}</p>
                <p class="a345 size12 ellipsis1 alignleft" style="color: red;" v-if="item.status == 4">{{ item.status_msg }}</p>
                <p class="Cred size13 alignleft"
                  v-if="item.status !== '11'&& item.status !== 7 &&item.status !== '12' && item.status != '24'&& item.status != '5' && item.status != '4'&&item.status != 6&&item.status != 10"
                  :class="{'c0185FF': (item.status == 23 || item.status == 25)}">{{ item.status_msg }}</p>
                <p class="a345 C999 weight  size15 alignleft"  v-if=" item.status == 6">{{ item.status_msg }}</p>
                  
                <p class="a345 Cred size10 ellipsis3 alignleft" v-if="item.status == '12' || item.status == 24">{{ item.status_msg }}</p>
                <div class="flex between width100" v-if="(item.status == 4 || item.status == 7||item.status == 10) && item.countdown > 0">
                  <p class="flex">
                    <img src="@/assets/img/icon25.png" class="clockimg" style="width:4.1vw;height:4.1vw;">
                    <van-count-down :format="item.countdown>60*60*24*7?'DD 天':'HH : mm : ss'" :time="item.countdown * 1000" class="C999" />
                  </p>
                 <p v-if="item.custom_reserve_price">￥{{ item.custom_reserve_price }}</p>
                </div>
                <p class="a345 C000 weight  size15 alignleft"  v-if=" item.status == 7 && item.price_status == 0">{{ item.status_msg }}</p>
                <p class="a345 Cred weight  size12 alignleft"  v-if=" item.status == 7 && item.price_status == 1">{{ item.status_msg }}</p>
                 
                <div class="flex" v-if="(item.status == '12' ||item.status == '24') && item.countdown > 0">
                  <img src="@/assets/img/icon25.png" class="clockimg" style="width:4vw;height:4vw;margin-left:3vw">
                  <van-count-down :format="item.countdown>60*60*24*7?'DD 天':'HH : mm : ss'" :time="item.countdown * 1000" class="C999" />
                </div>
              </div>
              <div class="flex between">
                <div class="flex" v-if="(item.status == 5) && item.countdown > 0">
                <img src="@/assets/img/icon25.png" class="clockimg" style="width:4vw;height:4vw;">
                <van-count-down :format="item.countdown>60*60*24*7?'DD 天':'HH : mm : ss'" :time="item.countdown * 1000" class="C999" />
              </div>
              <p class="Cred" v-if="item.status == 5 && item.sales_method == 2"> ￥{{ item.total_amount }}</p>
              </div>
              
              <!-- <p class="pad4" v-if="item.status !== 12 || item.status !== 24"></p> -->
              <p class="size12  ellipsis2 w210vw" v-if="item.status == 2">自提时间：{{ item.pickup_time }}</p>
              <p class="size14 c999999 ellipsis2 w210vw" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                v-if="item.status == 2">卖家地址：{{ item.status_desc }}</p>
              <p v-if="(item.warn !== '' || (item.warn !== '' && item.countdown < 604800))&&item.status !== 4" class="size10 c999999 ellipsis2 w210vw"
                style="color: red">
                {{ item.warn }}
              </p>
              <p v-if="item.warn == ''  && item.status !== '13' && item.status !== '12' && item.status !== '24' && item.status != '2' && (item.status !== 3 && item.sales_method == 2)"
                class="size12 c999999 ellipsis2 w210vw">{{ item.status_desc }}</p>
              <p v-if="item.status == 8 && item.sales_method !== 2"  class="size12 c999999 ellipsis2 w210vw">{{ item.status_desc }}</p>
                <div v-if="item.status == 3 && item.sales_method == 2" class="flex between">
                  <p class="size12 c999999 ellipsis2">{{ item.status_desc }}</p>
                  <!-- <p class="size12 Cred">￥{{ item.total_amount }}</p> -->
                </div>
              <!-- <p v-if="item.status == 25" style="color: red" class="size16 a345">已赔付¥{{ item.claim_amount }}</p>
          <p v-if="item.status == 25" class="size12" style="color: #666666">已退回<span style="color: red">{{ item.refund_money }}</span></p> -->
              <p v-if="item.status == 13 && item.claim_amount > 0" style="color: red" class="size16 a345">已赔付¥{{ item.claim_amount }}</p>
              <p v-if="item.status == 13" class="size12" style="color: #666666">已退回<span style="color: red">{{ item.refund_money }}</span></p>

              <p class="size12" v-if="item.status == '12' || item.status == 24">{{ item.refund_msg }}</p>
              <p class="size12" v-if="item.status == '11'">{{ item.status_msg }}</p>
              <p v-if="([1,3,4,6,7,8,'11','21','22','23','25'].includes(item.status)) && item.total_amount != 0" class="size12 Cred" style="text-align:right">实付:{{ item.total_amount }}</p>
              <!-- <div v-if="item.status !== 2 && item.status !== 4 &&item.status !== 5&&item.status !== '13'"
                style="width:100%;justify-content:space-between;" class="flex size11">
                <div class="spec-num">{{item.spec_num}}</div>
                <p style="color:red;width:30%;text-align:right;overflow: hidden;text-overflow: ellipsis;word-wrap: normal;">
                  ￥{{item.total_amount}}</p>
              </div> -->
            </div>

          </router-link>
          <div class="flex end" style="justify-content:flex-end;">
            <ul class="relative" v-if="!(item.sales_method == 2 && item.price_status == 0 && item.status == 7|| item.status == 9||item.status ==10)  ">
              <p class="size14 c999999" style="padding:2px 0;" @click.stop="handleMore(index,item)">更多</p>
              <li ref="morelist" style="z-index:9999"  class="absolute flex zIndex1 cen t l mt30 BGwhite size15 pad10 gray radius4 center width90px" v-show="item.toast">
                <div ref="leng" class="BGwhite pad5 rotate45 absolute" style="top: -4px; left: 10px"></div>
                <div>
                  <p v-if="item.status == 5 && item.sales_method == 2"  @click="
                    $router.push({
                      path: '/shop/evaluate',
                      query: { order_id: item.order_id },
                    })
                  ">查看评价</p>
                  <hr v-if=" item.status == 5&& item.sales_method == 2" class="pad4 mt8" />

                  <p v-if="(item.status == 4 || item.status == 5 || item.status == 6) && item.sales_method == 2" @click="
                    $router.push({
                      path: '/shop/order/schedule',
                      query: { id: item.order_id },
                    })
                  ">查看进度</p>
                  <hr v-if="(item.status == 4 || item.status == 5  || item.status == 6) && item.sales_method == 2" class="pad4 mt8" />
                  <p v-if="(item.status == 3 || item.status == 8) && item.sales_method == 2" @click="$router.push({
                      path: '/shop/order/contract',
                      query: { order_id: item.order_id },
                    })
                  ">查看合同</p>
                  <hr v-if="(item.status == 3 || item.status == 8) && item.sales_method == 2" class="pad4 mt8" />
                  <p v-if="item.status !== 7 && item.sales_method == 1" @click="handleShowJiaGou(item.order_id)">再次加购</p>
                  <hr v-if="item.status !== 7 && item.sales_method == 1" class="pad4 mt8" />
                  <p v-if="item.status == 1 || item.status == 2 || item.status == 7|| item.status == 8 || (item.status == 3 && item.sales_method == 2)" @click="
                      $router.push({
                        path: '/shop/cancel/edit',
                        query: { id: item.order_id },
                      })
                    ">
                    取消订单
                  </p>
                  <hr v-if="item.status == 1 || item.status == 2 || item.status == 7 || item.status == 8 || (item.status == 3 && item.sales_method == 2)" class="pad4 mt8" />
                  <p v-if="(item.status == 3 || item.status == 5 || item.status == 4) && item.sales_method !== 2" @click="
                      $router.push({
                        path: '/shop/return/edit',
                        query: { id: item.order_id },
                      })
                    ">
                    申请退货
                  </p>
                  <hr v-if="(item.status == 3 || item.status == 5 || item.status == 4) && item.sales_method !== 2" class="pad4 mt8" />
                  <p v-if="item.status == 24 || item.status == 22 || item.status == 23" @click="cancel(item, index)">撤销申请</p>

                  <hr class="pad4 mt8" v-if="item.status == 24 || item.status == 22 || item.status == 23" />

                  <p @click="
                      $router.push({
                        path: '/shop/accident/submit',
                        query: { id: item.order_id },
                      })
                    ">
                    事故申诉
                  </p>
                  <hr class="pad4 mt8" v-if="item.status != 6" />
                  <p v-if="item.status == 23 || item.status == 22" @click="handleRuturnMoney(item)">损失赔付</p>
                  <hr class="pad4 mt8" v-if="item.status == 23 || item.status == 22" />
                  <p v-if="item.survey_status" @click="$router.push({
                    path:'/shop/order/survey',
                    query:{order_id:item.order_id},
                  })">调查报告</p>

                </div>
              </li>
            </ul>
            <div class="C999 flex  ml10 size14  nowrap">
              <template v-if="item.status === 10">
                <div class="btn Con" @click="
                $router.push({
                      path: '/shop/order/auction',
                      query: { order_id: item.order_id },
                    })
                ">
                   立即付款
                </div>
              </template>
              <template v-if="item.status === 32">
                <div class="btn c333333" @click="
                    $router.push({
                      path: '/shop/accident/judgment',
                      query: { order_id: item.order_id },
                    })
                  ">
                  判决文书
                </div>
              </template>
              <template v-if="item.status == 21">
                <div class="btn c333333" @click="
                    $router.push({
                      path: '/shop/return/detail1',
                      query: { id: item.order_id, title: '申请详情' },
                    })
                  ">
                  查看详情
                </div>
              </template>
              <template v-if="item.status == 11">
                <div class="btn c333333" @click="
                    $router.push({
                      path: '/shop/cancel/detail1',
                      query: { id: item.order_id,title: '取消订单'},
                    })
                  ">
                  查看详情
                </div>
              </template>
              <template v-if="item.status == 12 || item.status == 13">
                <div class="btn c333333" @click="
                    $router.push({
                      path: '/shop/cancel/detail2',
                      query: { order_id: item.order_id,title:'申请详情',typeTitle:'取消订单'},
                    })
                  ">
                  查看详情
                </div>
              </template>
              <template v-if="item.status == 24 || item.status == 23 || item.status == 22">
                <div class="btn c333333" @click="
                    $router.push({
                      path: '/shop/return/detail2',
                      query: { order_id: item.order_id,title:'申请详情'},
                    })
                  ">
                  查看详情
                </div>
              </template>
              <template v-if="item.status == 31">
                <div class="btn c333333" @click="handleShowJiaGou(item.order_id)">
                  再次加购
                </div>
              </template>
              <template v-if="item.status == 25">
                <div class="btn c333333" @click="
                    $router.push({
                      path: '/shop/accident/returncomplete',
                      query: { id: item.order_id,title:'退货完成',type:'th'},
                    })
                  ">
                  查看详情
                </div>
              </template>
              <template v-if="item.status === 2 || (item.address_type == 2 && item.status == 8)">
                <div class="btn c333333" @click="handleFixTime(item.order_id)">
                  修改时间
                </div>
              </template>
              <template v-if="item.status === 1 || (item.address_type == 1 && item.status == 8)">
                <div class="btn c333333" @click="
                    $router.push({
                      path: '/address',
                      query: { type: 'select',id: item.order_id },
                    })
                  ">
                  修改地址
                </div>
              </template>
              <template v-if="(item.status === 3  || item.status === 4  || item.status === 5 || item.status === 6) && (item.sales_method == 1 ||item.sales_method == 3) ">
                <div class="btn c333333" @click="
                    $router.push({
                      path: '/shop/order/logis',
                      query: { id: item.order_id, typeid: 1 },
                    })
                  ">
                  查看物流
                </div>
              </template>
              <template v-if="item.status === 3  && item.sales_method == 2">
                <div class="btn C333" @click="
                    $router.push({
                      path: '/shop/order/schedule',
                      query: { id: item.order_id },
                    })
                  ">
                  查看进度 
                </div>
              </template>
              <template v-if="item.status === 3 && item.sales_method == 2">
                <div class="btn Con" @click="handleTakegoods(item.order_id,index)">
                    确认收货
                </div>
              </template>
              <!-- <template v-if="item.btn.cancel_claim === 1">
                <div
                  class="btn c333333"
                  @click="
                    $router.push({
                      path: '/shop/return/detail2',
                      query: { order_id: item.order_id, title: '损失赔付' },
                    })
                  "
                >
                损失赔付
                </div>
              </template> -->
              <template v-if="(item.status == 3 && item.sales_method == 1 )||(item.status == 3 && item.sales_method == 3 ) || item.status == 2">
                <div class="btn Con" @click="handleTakegoods(item.order_id,index)">
                  确认收货
                </div>
              </template>
              <template v-if="item.status == 7 && item.price_status ==0">
                <div class="btn c333333" @click="
                      $router.push({
                        path: '/shop/accident/submit',
                        query: { id: item.order_id },
                      })
                    ">
                  事故申诉
                </div>
              </template>
              <template v-if="item.status == 9">
                <div class="btn Con" @click="
                      $router.push({
                        path: '/shop/accident/submit',
                        query: { id: item.order_id },
                      })
                    ">
                  事故申诉
                </div>
              </template>
              <template v-if="item.status == 7">
                <div class="btn" :class="item.price_status? 'C000' : 'Con'" @click="$router.push({
                      path: '/shop/order/contract',
                      query: { order_id: item.order_id },
                    })
                  ">
                  查看合同
                </div>
              </template>
              <template v-if="(item.status == 4 || item.status == 5 || item.status == 6 )&& item.sales_method == 2">
                <div class="btn C000" @click="$router.push({
                      path: '/shop/order/contract',
                      query: { order_id: item.order_id },
                    })
                  ">
                  查看合同
                </div>
              </template>
              <template v-if="item.status == 7 && item.price_status">
                <div class="btn Con" @click="customZf(item)" >
                  立即支付
                </div>
              </template>
              <template v-if="item.status == 1">
                <div class="btn Con" @click="handleRemind(item.order_id)">
                  提醒发货
                </div>
              </template>
              <template v-if="item.status == 24 || item.status == 12">
                <div class="btn Con" @click="handleRuturnMoney(item)" v-if="item.refund_money > 0">
                  损失赔付
                </div>
                <div class="btn Con" v-if="item.refund_money < 0" @click="confirmRuturnMoney">
                  确认损失
                </div>
              </template>
              <template v-if="item.status == 6 ">
                <div class="btn Con" @click="
                    $router.push({
                      path: '/shop/evaluate',
                      query: { order_id: item.order_id },
                    })
                  ">
                  查看评价
                </div>
              </template>
              <template v-if="item.status == 5">
                <div class="btn Con" @click="handleQrJz(item.order_id,item.sales_method)">
                  立即结账
                </div>
              </template>
              <template v-if="item.status == 21">
                <div class="btn Con" @click="cancel(item, index)">撤销申请</div>
              </template>
              <template v-if="item.status == 11">
                <div class="btn Con" @click="cancel(item, index)">撤销申请</div>
              </template>
              <!-- <template v-if="item.btn.cancel_claim === 1">
                      <div class="btn Con"  @click="$router.push({path:'/shop/return/detail2',query:{ order_id:item.order_id,title:'损失赔付'}})">损失赔付</div>
                    </template> -->
              <template v-if="item.status == 22">
                <div class="btn Con" @click="
                    $router.push({
                      path: '/shop/return/detail3',
                      query: { id: item.order_id },
                    })
                  ">
                  商品退回
                </div>
              </template>
              <template v-if="(item.status == 23 || item.status == 25)&&(item.btn.refund_viewlogistics == 1)">
                <div class="btn Con" @click="
                    $router.push({
                      path: '/shop/order/logis',
                      query: { id: item.order_id, typeid: 2 },
                    })
                  ">
                  查看物流
                </div>
              </template>
              <!-- <template v-if="item.btn.accident_process === 1">
                <div
                  class="btn Con"
                  @click="
                    $router.push({
                      path: '/shop/accident/schedule',
                      query: { id: item.order_id },
                    })
                  "
                >
                  查看进程
                </div>
              </template> -->
              <template v-if="item.status === 4">
                <div class="btn Con" @click="
                    $router.push({
                      path: '/shop/evaluate',
                      query: { order_id: item.order_id },
                    })
                  ">
                  立即评价
                </div>
              </template>
              <template v-if="item.status === 8">
                <div class="btn Con" @click="handleAudit(item.order_id)" >
                  提醒审核
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-list>
</van-pull-refresh>

  <van-popup v-model:show="timeshow" :style="{ padding: '10px 25px', width: '90%' }" :round="true">
    <div class="popuptemplate">
      <van-picker title="选择取货时间" :columns="columns" @change="handleChange" :swipe-duration="100">
        <template #toolbar>
          <div class="vanpickertop">
            <p>选择取货时间</p>
          </div>
        </template>
        <template #columns-bottom>
          <button class="pick-timeconfirm" @click="handleConfirmTime">
            确定
          </button>
        </template>
      </van-picker>
      <img src="@/assets/img/icon32.png" class="pickerclose" @click="handleShow" />
    </div>
  </van-popup>
  <van-popup v-model:show="showJzBottom" position="bottom">
    <div class="jiezhang">
      <p class="jiezhang__tle a345">是否确认结账</p>
      <div class="flex center jiezhang-store">
        <img :src="jzInfo.store.head_pic" :onerror="Imgerror" />
        <p class="a345 size14">{{ jzInfo.store.store_name }}</p>
      </div>
      <div class="flex jiezhang-goods">
        <img :src="jzInfo.goods.original_img" :onerror="Imgerror" />
        <p>{{ jzInfo.goods.goods_name }}</p>
      </div>
      <div class="jiezhang-regular" v-if="sales_method == 1">
        <ul>
          <li v-for="item in jzInfo.goods_spec" :key="item.spec_key_name" class="flex between center">
            <p>{{ item.spec_key_name }}</p>
            <p>¥{{ item.goods_price }}</p>
            <p>x{{ item.goods_num }}</p>
            <p>¥{{ item.total_price }}</p>
          </li>
        </ul>
      </div>
      <p class="jiezhang-total">
        <span class="size14">共计:</span><span class="size14">¥</span><span class="size24">{{ jzInfo.order_info.total_amount }}</span>
      </p>
      <button class="jiezhang-btn" @click="handleConfirmJz">确定支付</button>
    </div>
  </van-popup>
  <van-popup v-model:show="showJiaGouBottom" position="bottom" style="z-index: 999999">
    <div class="popup">
      <Steeper :goodsInfo="goodsInfo" :handleSj="'jg'" typeName="again" @closeJs="closeJs"></Steeper>
    </div>
  </van-popup>
  <!-- 定制立即支付页面 -->
  <van-popup v-model:show="showZfBottom" position="bottom" :style="{ height: '90%' }">
    <CustomPay v-model:goodsInfo="customInfo" @closeJs="closeCustom" @totalAmount="totalAmount"></CustomPay>
  </van-popup>
  <PayDialog v-model:showPopup="showPay" v-model:amount="amount" :nextFn="nextFn"></PayDialog>
  <PayDialog v-model:showPopup="showCustom" :title="'支付'"  v-model:amount="amount" :nextFn="customNextFn"></PayDialog>
</template>
<script>

</script>
<script setup>
import PayDialog from "@/components/PayDialog.vue"
import Steeper from "../detail/jiesuan.vue";
import CustomPay from '../detail/custompay.vue'
import { ref, defineProps, defineEmits, watch } from "vue";
import { showDialog, showToast } from "vant";
import ajax from "@/utils/request.js";
// import { useRoute } from "vue-router";
// 下拉更新状态
const isLoading = ref(false);
// 下拉刷新
const onRefresh = ()=>{
  page.value = 1
  getList().finally(() => {
    loading.value = false;
    isLoading.value = false;
  });
}
// const route = useRoute
// 支付弹窗状态
const showZfBottom = ref(false);
// 支付选择
const showCustom = ref(false);
const customInfo = ref('');
// 打开定制支付状态
const customZf = info => {
  customInfo.value = info
  showZfBottom.value = true
}
// 定制选择后的处理
const customNextFn = async (amount, type) => {
  const data = {
    no:customInfo.value['order_sn'],
    typeid:type,
    total_amount:amount,
    return_url:location.origin + "/" + location.hash,
  }
  if(type == 3){
        const response = await ajax.post("users/userid");
        const userId = response.data.user_id;
        // 更新 data 对象的 user_id 属性
        data.user_id = userId;
      }
  ajax.post('pay/pay',data)
      .then(res=>{
          window.open(res.data.info)
      })
}
const closeCustom = () => {
  showZfBottom.value = false
}
const totalAmount = val => {
  amount.value = val
  showZfBottom.value = false
  showCustom.value = true
}
const props = defineProps({
  keyword: {
    type: String,
    default: "",
  },
  status: {
    type: Number,
    default: 0,
  }
});

const oldkeyword = ref(props.keyword)

// const activeProps = defineProps({
//   active: {
//     type: Number,
//   }
// })

const loading = ref(false);
// const page = ref(1);
const finished = ref(false);

const closeToast = () => {
  goodsList.value.map((item) => {
    item.toast = false;
  });
};

//获取列表
const page = ref(1);
const goodsList = ref([]);
const emits = defineEmits('updatecount')
const getList = () => {
  loading.value = true;
  const data = {
    status: props.status,
    page: page.value,
    keyword: props.keyword,
  };
  return ajax
    .post("order/getlist", data)
    .then((res) => {
      res.data.map((item) => {
        item.toast = false;
      });
      if (res.data.length < 10) {
        goodsList.value = goodsList.value.concat(res.data);
        finished.value = true;
      } else {
        goodsList.value = goodsList.value.concat(res.data);
        page.value++;
      }
      emits('updatecount', res.total)
    }).catch(() => {
      finished.value = true;
    })
};
getList().finally(() => {
  loading.value = false;
});

const onLoad = () => {
  loading.value = true;
  getList().finally(() => {
    loading.value = false;
  });
};
//撤销申请
const cancel = (item, index) => {
  showDialog({
    showCancelButton: true,
    cancelButtonText: "取消",
    confirmButtonText: "确定",
    message: "确认撤销申请？",
  })
    .then(() => {
      const data = {
        id: item.order_id
      }
      ajax.post('order/revoke', data).then(res => {
        if (res.errcode == 1) {
          showToast(res.message)
          page.value = 1
          goodsList.value = []
          getList().finally(() => {
            loading.value = false;
          });
        }
      })
    })
    .catch(() => { });
};
//确认收货
const handleTakegoods = (order_id, index) => {
  const data = {
    id: order_id,
  };
  ajax.post("order/confirmdelivery", data).then((res) => {
    if (res.errcode === 1) {
      showToast("确认收货");
      goodsList.value.splice(index, 1)
    }
  });
};
//提醒发货
const handleRemind = (id) => {
  const data = {
    id: id,
  };
  ajax.post("order/remind", data).then((res) => {
    if (res.errcode) {
      showToast(res.message);
    }
  });
};

//提醒审核
const handleAudit = (id) => {
  const data = {
    id: id,
  };
  ajax.post("order/audit", data).then((res) => {
    if (res.errcode) {
      showToast(res.message);
    }
  });
};
//修改时间
const columns = ref([]);
const timeshow = ref(false);
const timeOrder = ref(); //当前修改时间订单
const timedata = ref(); //自提时间
const timenum = ref(1); //获取左边时间时，添加timenum，辨别数组
const dateArr = ref([]); //存放时间
const trade_time = ref(""); //自提时间
//存放左边的时间
const leftArr = ref([])
//存放右边的时间的值
const rightArr = ref([])
const handleFixTime = (id) => {
  //初始化存放数据
  dateArr.value = []
  timenum.value = timenum.value * (Math.random() * 10)
  trade_time.value = ""
  timeOrder.value = ""
  columns.value = []
  leftArr.value = []
  rightArr.value = []
  ajax.post("order/gettradetime", { id: id }).then((res) => {
    const data = res.data.trade_time;
    timedata.value = res.data.trade_time[0].value; //默认时间为第一个
    data.forEach(v => {
      const obj = dateArr.value.find(item => {
        return item.text === v.title
      })
      if (!obj) {
        dateArr.value.push({ text: v.title, value: [{ text: v.time, value: v.value }] })
      } else {
        obj.value.push({ text: v.time, value: v.value })
      }
    })

    //获取第一个时间，初始化时放第一个时间的值
    const time = data[0].title
    // //存放左边的时间
    // const leftArr = []
    // //存放右边的时间的值
    // const rightArr = []
    data.forEach((item) => {
      //获取左边的时间
      const leftObj = leftArr.value.find(lt => {
        return lt.text === item.title
      })
      if (!leftObj) {
        leftArr.value.push({ text: item.title, value: Math.random(), type: timenum.value })
      }
      timenum.value++
      //获取右边的时间的值
      if (item.title === time) {
        rightArr.value.push({ text: item.time, value: item.value, type: 'right' })
      }
    });
    //初始化时间数组
    columns.value.push(leftArr.value)
    columns.value.push(rightArr.value)
    //初始化timenum，后面用于辨别左边时间更换
    timenum.value = leftArr.value[0].type

  });
  timeshow.value = true;
  timeOrder.value = id;
};

const handleChange = (selectedValues) => {
  // timedata.value = selectedValues.selectedValues[0];
  if (timenum.value !== selectedValues.selectedOptions[0].type) {
    const obj = dateArr.value.find(item => {
      return item.text === selectedValues.selectedOptions[0].text
    })
    columns.value[1] = obj.value
    trade_time.value = columns.value[1][0].value
    timenum.value = selectedValues.selectedOptions[0].type
  } else {
    trade_time.value = selectedValues.selectedValues[1]
  }
};
const handleShow = () => {
  timeshow.value = !timeshow.value
}
//提交修改时间
const handleConfirmTime = () => {
  if (trade_time.value === "") {
    trade_time.value = columns.value[1][0].value
  }
  const data = {
    id: timeOrder.value,
    time: trade_time.value,
  };
  ajax.post("order/settime", data).then((res) => {
    if (res.errcode === 1) {
      showToast(res.message);
      setTimeout(() => {
        timeshow.value = false;
      }, 500);
    }
  });
};
//确认结账
const showJzBottom = ref(false);
const jzInfo = ref();
// 当前订单销售方式
const sales_method = ref(1);
const currentJzOrder = ref();
const handleQrJz = (id,sales) => {
  showJzBottom.value = true;
  currentJzOrder.value = id;
  sales_method.value = sales
  ajax.post("order/getinfo", { id: id }).then((res) => {
    jzInfo.value = res.data;
  });
};
const handleConfirmJz = () => {
  ajax.post("order/checkout", { id: currentJzOrder.value }).then((res) => {
    if (res.errcode === 1) {
      showJzBottom.value = false;
      showToast("结账成功");
      page.value = 1
      goodsList.value = []
      getList().finally(() => {
        loading.value = false;
      });
    }
  });
};
//再次加购
const goodsInfo = ref()
const showJiaGouBottom = ref(false)
const goods_id = ref()
const handleShowJiaGou = (id) => {
  ajax.post("order/getpurchase", { id: id }).then(res => {
    goods_id.value = res.data.goods.goods_id
    ajax.post("products/getinfo", { goods_id: goods_id.value }).then(goodsRes => {
      const goodsInfoList = goodsRes
      goodsInfoList.data.spec.forEach(item => {
        item.sum = 0
      })
      res.data.goods_spec.forEach(v => {
        const obj = goodsInfoList.data.spec.find(item => {
          return item.item_id = v.item_id
        })

        obj.sum = v.num
      })
      goodsInfo.value = goodsInfoList.data
      showJiaGouBottom.value = true
    })
  })
}
const closeJs = () => {
  showJiaGouBottom.value = false
}
//查看更多
const pretoast = ref(0)
const morelist = ref()
const leng = ref()
const handleMore = (index, item) => {
  if (index == (goodsList.value.length - 1)) {
    morelist.value[index].style.bottom = '30px'
    morelist.value[index].style.top = 'unset'
    leng.value[index].style.bottom = '-4px'
    leng.value[index].style.top = 'unset'
  }
  if (pretoast.value == index) {
    item.toast = !item.toast
  } else {
    goodsList.value[pretoast.value].toast = false
    pretoast.value = index
    item.toast = !item.toast
  }
}
//损失赔付
const showPay = ref(false)
const amount = ref(null)
const payno = ref()
const handleRuturnMoney = (item) => {
  showPay.value = true
  amount.value = item.claim_amount
  payno.value = item.refund_sn
}
const nextFn = async (amount, type) => {
  const data = {
    typeid: type,
    no: payno.value,
    return_url: location.origin + '/#/shop/order?type=' + 4
  }
  if(type== 3){
        const response = await ajax.post("users/userid");
        const userId = response.data.user_id;
        // 更新 data 对象的 user_id 属性
        data.user_id = userId;
        data.total_amount = amount;
      
      }
  ajax.post("pay/pay", data).then(res => {
    if (res.errcode === 1) {
      window.location.href = res.data.info;
    }
  })
}
//确认损失
const confirmRuturnMoney = () => {
  showToast('已确认损失')
}
const oldactive = ref()
watch(props, () => {
  // if (props.status !== oldactive.value) {
  //   finished.value = false
  //   page.value = 1
  //   goodsList.value = []
  //   oldactive.value = props.status
  //   getList().finally(() => {
  //     loading.value = false;
  //   });
  // }
  if (props.keyword !== oldkeyword.value) {
    finished.value = false
    page.value = 1
    goodsList.value = []
    getList().finally(() => {
      loading.value = false;
      oldkeyword.value = props.keyword
    });
  } else if (props.status !== oldactive.value) {
    finished.value = false
    page.value = 1
    goodsList.value = []
    oldactive.value = props.status
    getList().finally(() => {
      loading.value = false;
    });
  }
}, { deep: true })
</script>
<style scoped lang="scss">
.spec-num{
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.alignleft {
  text-align: left;
  word-break: break-all;
}
.maxwidth {
  width: calc(100% - 26.6667vw - 10px);
}
.c0185FF {
  color: #0185FF;
}
.w210vw {
  width: 56vw;
}
.start-right {
  height: 26.6667vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.c333333 {
  color: #333333
}
.c999999 {
  color: #999999;
}
.gray {
  box-shadow: 0 -2px 25px 1px rgba(0, 0, 0, 0.1);
}
.graycolor {
  color: #999999;
}
.order-list {
  padding: 3.2vw;
  background-color: #fff;
  border-radius: 2.1333vw;
  margin-bottom: 2.6667vw;
  .lookbar {
    margin-bottom: 2.6667vw;
  }
  img {
    display: block;
    width: 26.6667vw;
    height: 26.6667vw;
    object-fit: cover;
  }
  .order-info {
    padding-left: 1vw;
    p {
      &:first-child {
        font-size: 14px;
        color: #333333;
      }
      &:nth-child(2) {
        font-size: 12px;
        color: #999999;
        margin-top: 2.6667vw;
        margin-bottom: 3.4667vw;
      }
    }
    .order-info-btn {
      a {
        &:first-child {
          font-size: 3.2vw;
          color: #999999;
        }
        &:nth-child(2) {
          padding: 1.3333vw 3.2vw;
          font-size: 3.7333vw;
          color: #333333;
          border: 1px solid #cccccc;
          border-radius: 4vw;
          margin-right: 3vw;
          margin-left: 3vw;
        }
        &:last-child {
          padding: 1.3333vw 3.2vw;
          font-size: 3.7333vw;
          color: #3f7c93;
          border: 1px solid #cccccc;
          border-radius: 4vw;
        }
      }
    }
  }
}
.btn {
  padding: 5px 10px;
  border: solid 1px #dbdbdb;
  border-radius: 20px;
  font-size: 14px;
  line-height: 1.3;
  & + .btn {
    margin-left: 8px;
  }
}
//弹窗及日期自定义
.vanpickertop {
  width: 100%;
  position: relative;
  p {
    text-align: center;
    font-size: 16px;
    color: #666666;
  }
}
.popuptemplate {
  position: relative;
}
.pickerclose {
  position: absolute;
  width: 3.7333vw;
  height: 3.7333vw;
  right: -11px;
  top: 0;
}
.pick-timeconfirm {
  width: 100%;
  height: 9.6vw;
  line-height: 9.6vw;
  text-align: center;
  background: #3f7c93;
  border-radius: 21px;
  margin: 0 auto;
  font-size: 14px;
  color: #ffffff;
}
.jiezhang {
  padding: 5.3333vw 4vw 3.4667vw;
  .jiezhang__tle {
    text-align: center;
    font-size: 16px;
    color: #333333;
  }
  .jiezhang-store {
    margin-top: 7.7333vw;
    img {
      width: 4.8vw;
      height: 4.8vw;
      border-radius: 50%;
      margin-right: 1.0667vw;
    }
    p {
      color: #333333;
    }
  }
  .jiezhang-goods {
    margin-top: 2.6667vw;
    img {
      width: 26.6667vw;
      height: 26.6667vw;
      background: #ffffff;
      border-radius: 1.0667vw;
    }
    p {
      width: 56.2667vw;
      font-size: 14px;
      color: #333333;
      margin-left: 2.6667vw;
    }
  }
  .jiezhang-regular {
    margin-top: 5.3333vw;
    ul li {
      margin-bottom: 3.2vw;
      p {
        font-size: 14px;
        color: #333333;
        &:first-child {
          padding: 1.3333vw 5.3333vw;
          background: #f6f6f6;
          border-radius: 0.5333vw;
          color: #999999;
        }
        &:nth-child(3) {
          border: 1px solid rgba(204, 204, 204, 0.3);
          padding: 1.3333vw 0.8vw;
        }
        &:last-child {
          font-size: 18px;
          color: #ff0000;
        }
      }
    }
  }
  .jiezhang-total {
    text-align: right;
    color: #ff0000;
    letter-spacing: 1px;
    span {
      &:first-child {
        color: #333333;
      }
    }
  }
  .jiezhang-btn {
    width: 92vw;
    height: 9.6vw;
    line-height: 9.6vw;
    text-align: center;
    background: #e30000;
    border-radius: 21px;
    font-size: 14px;
    color: #ffffff;
    margin-top: 10.6667vw;
  }
}
.jiagoubox {
  background-color: #fff;
  padding: 5.3333vw 4vw;
}
// .jiagoubox-tle {
//   padding-left: 9.6vw;
//   padding-right: 3.4667vw;
// }
.jiagoubox-tle-left {
  img {
    width: 5.3333vw;
    height: 5.3333vw;
    background: #FFFFFF;
    border-radius: 50%;
    margin-right: .5333vw;
  }
  p {
    color: #333333;
    font-size: 14px;
  }
}
.jiagoubox-tle-right {
  display: block;
  width: 5.3333vw;
  height: 5.3333vw;
}
.jiagoubox-store {
  margin-top: 2.6667vw;
  img {
    width: 26.6667vw;
    height: 26.6667vw;
    background: #FFFFFF;
    border-radius: 1.0667vw;
    margin-right: 2.6667vw;
  }
  p {
    width: 56vw;
    font-size: 14px;
    color: #333333;
  }
}
//弹窗
.popup {
  padding: 6.4vw 4vw 17.0667vw;
  .popup-up-r {
    padding-left: 2.6667vw;
  }
  .popup-shopimg {
    width: 26.6667vw;
    height: 26.6667vw;
    object-fit: contain;
  }
  .popup-shopimg-small {
    display: block;
    width: 4.8vw;
    height: 4.8vw;
    object-fit: contain;
    border-radius: 50%;
    margin-right: 1.0667vw;
  }
  .popup-tle {
    width: 53.3333vw;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
  }
  .regular-box {
    padding-top: 5.3333vw;
  }
  .regular {
    margin-bottom: 3.2vw;
  }
  .regular-before {
    p {
      &:first-child {
        width: 26.1333vw;
        height: 8vw;
        line-height: 8vw;
        text-align: center;
        color: #999999;
        font-size: 14px;
        background: #F6F6F6;
        border-radius: .5333vw;
      }
      &:last-child {
        color: #999999;
        font-size: 12px;
        margin-left: 2.6667vw;
      }
    }
  }
  .regular-after {
    p {
      &:first-child {
        padding: 1.3333vw .8vw;
        text-align: center;
        border: 1px solid rgba(204, 204, 204, .2);
      }
      &:last-child {
        margin-left: 5.3333vw;
      }
    }
  }
}
.clockimg {

}
</style>